import { em, shade, tint } from 'polished'
import styled, { css } from 'styled-components'

import datepickerCSS from '!!raw-loader!react-dates/lib/css/_datepicker.css'

interface IDatePickerStyledProps {
  error: boolean
}

/** @deprecated Use the new DatePicker component instead */
export const DeprecatedDatePickerStyled = styled.div<IDatePickerStyledProps>`
  ${datepickerCSS}

  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .CalendarDay {
    vertical-align: middle;
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
    padding: ${(props) => props.theme.typography.pxToRem(2)} 0;

    > div {
      width: ${em(34, 12)};
      height: ${em(33, 12)};
      line-height: ${em(34, 12)};
    }
  }

  .SingleDatePickerInput,
  .DateRangePickerInput {
    border-color: ${(props) => props.theme.colors.form.datepicker.border};
    border-radius: ${(props) =>
      props.theme.typography.pxToRem(props.theme.shape.borderRadius)};

    &.SingleDatePickerInput__block {
      display: flex;
      flex-wrap: nowrap;
    }
    &.SingleDatePickerInput__disabled {
      background-color: ${(props) =>
        props.theme.colors.form.field.backgroundDisabled};
      border-color: ${(props) => props.theme.colors.form.field.borderDisabled};
    }
  }

  .DateInput {
    width: ${(props) => props.theme.typography.pxToRem(170)};
    max-width: ${(props) => props.theme.typography.pxToRem(170)};

    &.DateInput__block {
      width: 100%;
      max-width: none;
    }
  }

  .DateRangePicker {
    min-width: ${(props) => props.theme.typography.pxToRem(240)};
  }

  .DateInput,
  .DateInput_input {
    background: none;
    border: 0;
    padding: 0;
  }

  .DateRangePickerInput .DateInput {
    width: ${(props) => props.theme.typography.pxToRem(100)};
  }
  ${(props) =>
    props.error
      ? css`
          .SingleDatePickerInput,
          .DateRangePickerInput {
            border-color: ${props.theme.colors.form.datepicker.borderError};
          }
        `
      : {}}

  .DateInput_input {
    font-family: ${(props) => props.theme.typography.fontFamily};
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    font-style: normal;
    font-weight: ${(props) => props.theme.typography.fontWeightRegular};
    line-height: ${(props) => props.theme.typography.pxToRem(36)};
    padding: 0 ${(props) => props.theme.typography.pxToRem(12)};
    border: 0;
    height: ${(props) => props.theme.typography.pxToRem(36)};

    &.DateInput_input__focused {
      border-color: transparent;
      color: ${(props) => props.theme.colors.primary};
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
    }

    &.DateInput_input__disabled {
      color: ${(props) => props.theme.colors.form.field.textDisabled};
    }

    &.DateInput_input__disabled::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
    }
  }

  .DateRangePickerInput_arrow {
    margin-top: ${(props) => props.theme.typography.pxToRem(2)};
  }

  .CalendarDay__selected_span,
  .CalendarDay__hovered_span,
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: none;
    color: ${(props) =>
      shade(0.2, props.theme.colors.form.datepicker.selected)};

    > div {
      background: ${(props) =>
        tint(0.7, props.theme.colors.form.datepicker.selected)};
      border-color: transparent;
    }
  }

  .CalendarDay__default,
  .CalendarDay__default:hover,
  .CalendarDay__blocked_out_of_range,
  .CalendarDay__blocked_out_of_range:active,
  .CalendarDay__blocked_out_of_range:hover {
    border-color: transparent;
    background: none;
  }

  .CalendarDay__default:hover {
    > div {
      background: ${(props) =>
        tint(0.7, props.theme.colors.form.datepicker.selected)};
    }
  }

  .CalendarDay__highlighted_calendar,
  .CalendarDay__highlighted_calendar:active,
  .CalendarDay__highlighted_calendar:hover {
    background: ${(props) =>
      tint(0.85, props.theme.colors.form.datepicker.selected)};
    color: ${(props) =>
      shade(0.2, props.theme.colors.form.datepicker.selected)};
  }

  /* stylelint-disable no-descending-specificity */
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    > div {
      background: ${(props) => props.theme.colors.form.datepicker.selected};
    }
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    > div {
      background: ${(props) =>
        tint(0.5, props.theme.colors.form.datepicker.selected)};
    }
  }

  .CalendarDay__selected_start {
    > div {
      color: ${(props) => props.theme.colors.white};
      background: ${(props) =>
        tint(0, props.theme.colors.form.datepicker.selected)};
      border-radius: 50% 0 0 50%;
    }
  }

  .CalendarDay__selected_end,
  .CalendarDay__hovered_span:hover {
    > div {
      color: ${(props) => props.theme.colors.white};
      background: ${(props) =>
        tint(0, props.theme.colors.form.datepicker.selected)};
      border-radius: 0 50% 50% 0;
      border: none;
    }
  }
  /* stylelint-enable no-descending-specificity */

  .CalendarDay__selected_start.CalendarDay__selected_end {
    > div {
      border-radius: 50%;
    }
  }

  .CalendarMonth_caption {
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    font-weight: ${(props) => props.theme.fontWeights.bold};
    padding-bottom: ${(props) => props.theme.typography.pxToRem(44)};
  }

  .DayPicker_wrapper__horizontal {
    padding-bottom: 1em;
  }

  .DayPicker_weekHeader_li {
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
  }

  .SingleDatePicker .CalendarDay__selected {
    color: ${(props) => props.theme.colors.white};
    background: ${(props) =>
      tint(0, props.theme.colors.form.datepicker.selected)};
    border-radius: 50%;
  }

  .DateRangePickerInput_clearDates {
    margin-right: 0;
  }
  .DateRangePickerInput_calendarIcon,
  .SingleDatePickerInput_calendarIcon {
    padding: 0;
    margin: 0 ${(props) => props.theme.typography.pxToRem(12)} 0 0;

    &:focus {
      outline: none;
    }
  }
  .DateInput_fang {
    display: none;
  }
  .DayPicker__withBorder {
    box-shadow: ${(props) => props.theme.shadows[1]};
  }
`
